import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconLock = ({ t, fill, className, height, width }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox='0 0 39 39'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>{t('Lock')}</title>
    <g fill='none' fillRule='evenodd'>
      <rect x='1' width='39' height='39' rx='5' />
      <path fill='#888' d='M20.824 27.821h.006v4.424h-2.213v-4.424h.055a2.431 2.431 0 0 1 1.076-4.613 2.432 2.432 0 1 1 1.076 4.613zM8.613 16.666v-5.53c0-2.975 1.158-5.771 3.26-7.875A11.064 11.064 0 0 1 19.748 0c2.975 0 5.77 1.158 7.874 3.261a11.062 11.062 0 0 1 3.261 7.874v5.531h3.614v22.122H5V16.666h3.613zm3.834 0h14.6v-5.53c0-1.95-.758-3.784-2.137-5.163a7.252 7.252 0 0 0-5.162-2.138c-1.95 0-3.784.76-5.162 2.138a7.254 7.254 0 0 0-2.139 5.162v5.531z' />
    </g>
  </svg>
)

export default Icon(IconLock)
